import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from './IconUtils';

export const AddIcon = ({ id, onClick, size = 'small', className, disabled }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Add}
      alt="img"
      className={cn(styles.icon, className, getIconClasses(size, disabled))}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
    />
  );
};
